<template>
  <section class="pda-default">
    <!-- {{chatroomList}} -->
    <!-- <no-data v-if="isNoData"></no-data> -->

    <div class="mgt-16" v-if="isNoData">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-24 pdb-20">
        <div class="d-flex justify-content-center flex-column">
            <div class="t-center"><img src="images/no-data4.svg" alt="" class="w-44 h-44 mgx-auto"></div>
            <div class="t-color-content1 t-body3 l-spacing42 t-center mgt-24 font-r">
                {{ $t("1966") }}</br>
                {{ $t("1967") }}
            </div>
        </div>
      </div>
    </div>

    <div class="learn-question-card" v-if="!isNoData">
      <div
        class="mdc-card mdc-elevation--z2 pda-default"
        v-for="(chatroom, index) in chatroomList"
        :key="index"
        :class="{ 'mgt-16': index > 0 }"
        @click="moveQuestion(chatroom)"
      >
        <div class="t-body1">{{ chatroom.lessonName }}</div>
        <div class="t-body3 justify-content-between mgt-16 mgl-16 mgr-16">
          <div class="text-center">
            <div class="count-card">{{ chatroom.me + chatroom.other }}</div>
            <div class="t-color-content1 mgt-4">
              {{ $t("117") }} & {{ $t("119") }}
              <!-- 나의 질문 -->
            </div>
          </div>
          <!-- <div class="count">
                        <div class="t-headline9 box teacher" :class="{'on': chatroom.newTeacher}">
                            {{ chatroom.teacher }}
                        </div>
                        <div class="t-color-content1 mgt-4">
          {{$t('118')}}-->
          <!-- 강사 답변 -->
          <!-- <div class="dot" v-if="chatroom.newTeacher"></div>
                        </div>
          </div>-->
          <!-- <div class="count">
                        <div class="t-headline9 box friend" :class="{'on': chatroom.newOther}">
                            {{chatroom.other}}
                        </div>
                        <div class="t-color-content1 mgt-4 position-relative">
          {{$t('119')}}-->
          <!-- 동료 질문 -->
          <!-- <div class="dot" v-if="chatroom.newOther"></div>
                        </div>
          </div>-->
        </div>
      </div>
    </div>

    <transition name="slide">
      <router-view></router-view>
    </transition>
  </section>
</template>

<style scoped>
.count-card {
  border: 1px solid #ff847b;
  color: #ff847b;
  padding: 15px;
  border-radius: 4px;
}
.card-filled {
  color: #ffffff !important;
  background-color: #ff847b;
}

.mb-3-rem {
  margin-bottom: 3rem;
}
</style>

<script>
/**
 * 나의 학습 상세 - 질문하기 탭 컴포넌트(my learning view - question tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import NoData from "../../common/NoData.vue";
import learnApi from "@/api/learnApi.js";

export default {
  components: {
    "no-data": NoData,
  },

  data() {
    return {
      isNoData: false,
      chatroomList: [],
      lessonData: null,
      lessonNameList: [],
    };
  },

  mounted() {
    const ripples = [].map.call(
      document.querySelectorAll(".purchase-item"),
      function (el) {
        let ripple = new MDCRipple.attachTo(el);
        return ripple;
      }
    );

    let params = this.setParams();
    // 채팅 룸 정보(get chatting room list)
    learnApi
      .learnChatroomList(params)
      .then((response) => {
        let list = response.data.data.content;
        let paramss = { learnId: this.$route.params.learnId };
        learnApi
          .learnViewCourses(paramss)
          .then((response) => {
            this.lessonData = response.data.data;
            _.each(this.lessonData, (course) => {
              this.lessonNameList = this.lessonNameList.concat(course.lessons);
            });
            if (list) {
              for (let room in list) {
                for (let lesson of this.lessonNameList) {
                  if (list[room].lessonId === lesson.id) {
                    Object.assign(list[room], { lessonName: lesson.name });
                  }
                }
              }
            }

            this.chatroomList = list;
          })
          .catch((err) => {});

        if (!list.length) {
          this.isNoData = true;
        }
      })
      .catch((err) => {});

    // 채팅 룸 정보(get chatting room list)
    // learnApi
    //   .learnChatroomList(params)
    //   .then((response) => {
    //     this.chatroomList = response.data.data.content;

    //     if (!this.chatroomList.length) {
    //       this.isNoData = true;
    //     }
    //   })
    //   .catch((err) => {});
  },

  methods: {
    // move question
    moveQuestion(chatroom) {
      console.log("chatroom", chatroom);
      this.$router.push({
        name: "LearnViewQuestion",
        params: { lessonId: chatroom.lessonId },
      });
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        size: 100,
        learnId: this.$route.params.learnId,
      };
      return params;
    },
  },
};
</script>